<section class="dts tls" *ngIf="slide as s">
  <div class="dts-copy">
    <span class="dts-eyebrow"><img class="dts-eyebrow-logo" [src]="s.eyebrowIcon" alt="" width="18" height="18"/>{{ s.eyebrow }}</span>
    <h2 class="dts-title"><img class="dts-title-icon" [src]="s.icon" alt="" width="48" height="48"/>{{ s.title }}</h2>
    <p class="dts-lead">{{ s.lead }}</p>
    <p class="dts-text">{{ s.text }}</p>
    <ul class="dts-facts">
      <li *ngFor="let fact of s.facts">{{ fact }}</li>
    </ul>
    <div class="dts-actions">
      <a class="codigrate-button" [routerLink]="s.link" [queryParams]="s.queryParams || null" (click)="cta.emit( s.key )"><p>{{ s.cta }}</p></a>
    </div>
  </div>

  <div class="dts-show">
    <div class="dts-head">
      <h3 class="dts-headline"><span class="dts-accent">{{ s.accent }}</span> {{ s.rest }}</h3>
      <p class="dts-head-line">{{ s.line }}</p>
    </div>

    <!-- the live tools, every one rendered, the shown one on top (the home marks it .on) -->
    <div class="tls-stage">
      <ng-content></ng-content>
    </div>

  </div>

  <!-- every tool as its icon in one row centred under the box, the /tools page's groups
       (Color Tools, Generators, Converters) with a thin line between them, as the themes box's dock (owner
       2026-10-15: the chips had grown too many for the right side) -->
  <div class="tls-dock">
    <span class="tls-dock-label" aria-hidden="true">Tools</span>
    <div class="tls-tray" role="group" aria-label="Web tools">
      <ng-container *ngFor="let g of groups; let first = first; trackBy: trackGroup">
        <span class="tls-divider" *ngIf="!first" aria-hidden="true"></span>
        <!-- the icon alone, the name as its tooltip and label (owner 2026-10-19: no names in the dock) -->
        <button *ngFor="let t of g.items; trackBy: trackSlide" type="button" class="tls-poster"
                [class.on]="t.key === s.key" [attr.aria-pressed]="t.key === s.key"
                [attr.title]="t.chip" [attr.aria-label]="t.chip"
                (click)="pick.emit( t.key )">
          <img [src]="t.chipLogo || t.icon" alt="" width="22" height="22" loading="lazy" decoding="async" draggable="false"/>
        </button>
      </ng-container>
    </div>
  </div>
</section>
